import { JourneysLegacyAuthRefreshRoute } from './-components';
import { accountRouterRedirect, resolveAccountRedirect } from './-account-redirects';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/account/$')({
  // Legacy Unity `/account/*` URLs are forwarded to their canonical home natively.
  // Unmatched paths return null and fall through to the embedded Journeys app.
  // The query comes from the browser, not the router: the router parses each search value as JSON,
  // so its copy of a hex confirmation code that reads as a number is already changed.
  beforeLoad: ({ params }) => {
    const target = resolveAccountRedirect(params._splat ?? '', window.location.search);
    if (target != null) {
      throw accountRouterRedirect(target);
    }
  },
  component: JourneysLegacyAuthRefreshRoute,
});
